var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"outlined":"","color":"green"}},[_vm._v(_vm._s(_vm._f("points")(_vm.points)))])}
var staticRenderFns = []

export { render, staticRenderFns }